import { Form, FormProps } from 'antd';
import { FunctionComponent } from 'react';
import styled from 'styled-components';
import colors from 'theme/colors';

export const ResolutionItem = styled.div`
  width: 20rem;
  height: 13.375rem;

  background: ${colors.white};
  box-shadow: 0 0.063rem 0.25rem rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  padding: 1rem;
  margin-bottom: 1.5rem;
`;

export const ResolutionTitle = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1.5rem;
  margin-bottom: 0.625rem;
`;

export const ResolutionFormStyled: FunctionComponent<FormProps> = styled(Form)`
  .ant-form-item {
    margin-bottom: 0.625rem;
    .ant-form-item-label {
      width: 4.938rem;
      text-align: left;
    }

    .ant-form-item-control {
      width: 13.188rem;
    }
  }
`;
